import DataType from '@opsbase/lib-datatype/DataType';
import useAssets from '@opsbase/react-gql-hooks/asset/useAssets';
import useOrgIoTSensors from '@opsbase/react-gql-hooks/organisation/useOrgIoTSensors';
import useSelection from '@opsbase/web-data-selection/useSelection';
import Dialog from '@opsbase/web-dialogs/Dialog';
import DialogSize from '@opsbase/web-dialogs/Dialog/DialogSize';
import React, { useMemo } from 'react';
import { SensorCharts } from './SensorCharts';
export function AssetCompareDialog() {
    const dataType = DataType.ASSET;
    const { selecteds } = useSelection(dataType);
    const { data: allSensors } = useOrgIoTSensors();
    const { data: assets } = useAssets({
        variables: { id: selecteds.map(s => s.id) },
    });
    const sensors = useMemo(() => (assets === null || assets === void 0 ? void 0 : assets.length) && (allSensors === null || allSensors === void 0 ? void 0 : allSensors.length)
        ? allSensors.filter(s => !!assets.find(a => !!a.sensor && JSON.parse(a.sensor).sensorId === s.name))
        : [], [assets, allSensors]);
    return (React.createElement(Dialog, { size: DialogSize.X1000_Y500, padded: false, title: 'Compare' }, !!(sensors === null || sensors === void 0 ? void 0 : sensors.length) && React.createElement(SensorCharts, { sensors: sensors })));
}
export default AssetCompareDialog;
